// New UI_REVAMP
import { CheckCircleIcon, InfoIcon, WarningIcon, WarningTwoIcon } from '@chakra-ui/icons';
import { Box, Flex, Text } from '@chakra-ui/react';

const STATUS_COLOR_MAP = {
	success: '#2F855A',
	error: '#D7212C',
	info: '#2B6CB0',
	warning: '#C05621',
};

const STATUS_ICON_MAP = {
	success: CheckCircleIcon,
	error: WarningIcon,
	info: InfoIcon,
	warning: WarningTwoIcon,
};

const hexToRgba = (hex, alpha) => {
	const r = Number.parseInt(hex.slice(1, 3), 16);
	const g = Number.parseInt(hex.slice(3, 5), 16);
	const b = Number.parseInt(hex.slice(5, 7), 16);

	return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const getGradient = (color) => {
	return `linear-gradient(
    90deg,
    rgba(0,0,0,0) 0%,
    ${hexToRgba(color, 0.5)} 6.73%,
    ${color} 50%,
    ${hexToRgba(color, 0.5)} 90.87%,
    rgba(0,0,0,0) 100%
  )`;
};

export const CustomToast = ({ title, status, index }) => {
	const color = STATUS_COLOR_MAP[status];
	const Icon = STATUS_ICON_MAP[status];

	return (
		<Flex
			align='center'
			justify='center'
			py={2}
			px={10}
			color='white'
			minW='300px'
			maxW='90vw'
			borderTop={`1px solid ${color}`}
			borderBottom={`1px solid ${color}`}
			bg={getGradient(color)}
			mt={index === 0 ? '20px' : '8px'}
		>
			<Box mr={3}>
				<Icon boxSize={5} />
			</Box>

			<Text fontWeight='600' fontSize='14px'>
				{title}
			</Text>
		</Flex>
	);
};
